import ApiService from '@/service/apiService';
import Api from '@/config/api';

export default {
  state: {
    menus: [],
  },
  getters: {
    getMenus(state) {
      return state.menus;
    },
  },
  mutations: {
    setMenus(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.menus = data;
    },
  },
  actions: {
    async loadMenuConfigurations({ commit }) {
      try {
        const menus = await ApiService.get(Api.endpoints.FIELD);
        let menuData = menus.data.data;
        
        // Find the index of 登録日
        const registrationIndex = menuData.findIndex(menu => menu.title === '登録日');
        
        const newMenuItem = {
          title: 'リスト振分日',
          display: true,
          isReviewerOnly: true
        };

        if (registrationIndex !== -1) {
          // Insert before 登録日 if found
          menuData.splice(registrationIndex, 0, newMenuItem);
        } else {
          // Add to beginning of array if 登録日 not found
          menuData.unshift(newMenuItem);
        }
        commit('setMenus', menuData);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
